import React from 'react';

const ExpandIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60" }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { fill: props.backgroundColor, d: "M0 0H60V60H0z" }), /* @__PURE__ */ React.createElement("g", { fill: props.foregroundColor }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M4.333 15.167H5.413V27.084H4.333z",
    transform: "translate(17 17) rotate(45 4.873 21.125)"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M26 8h-1V1h-7V0h8v8z", transform: "translate(17 17)" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M20.583 -1.083H21.665999999999997V10.834H20.583z",
    transform: "translate(17 17) rotate(45 21.125 4.875)"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M0 26v-8h1v7h7v1H0z", transform: "translate(17 17)" }))));

export { ExpandIcon as default };
//# sourceMappingURL=ExpandIcon.js.map
